import PropTypes from 'prop-types'
import { Component } from 'react'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from 'react-places-autocomplete'

import TextInput from '../../../components/ReusableComponents/ManageHotel/TextInput/index'
import config from '../../../services/config'
import styles from './PlacesAutocomplete.module.scss'

function getComp(data, type, useShortName = true) {
  try {
    return data.address_components.find(c => c.types.includes(type))[
      useShortName ? 'short_name' : 'long_name'
    ]
  } catch (error) {
    return ''
  }
}

class Autocomplete extends Component {
  constructor(props) {
    super(props)
    this.state = { address: '', addressObject: {}, textValue: '' }
  }

  componentDidMount() {
    const { value, setValid } = this.props

    if (value) {
      this.setState({ address: value })
      setValid(true)
    }
  }

  handleChange = address => {
    const { setValid } = this.props

    setValid(false)
    this.setState({ address })
  }

  componentDidUpdate(prevProps) {
    if (this.props.disabled !== prevProps.disabled) {
      this.setState({ address: '' })
    }

    if (this.props.value !== prevProps.value) {
      this.setState({ address: this.props.value })
    }
  }

  handleSelect = async address => {
    const { setAddressObj, setValue } = this.props

    this.props.setValid(true)

    const [data] = await geocodeByAddress(address)
    const city =
      getComp(data, 'locality', false) ||
      getComp(data, 'administrative_area_level_3', false)
    const stateCode = getComp(data, 'administrative_area_level_1')
    const countryCode = getComp(data, 'country')
    const postalCode = getComp(data, 'postal_code')
    const streetAddress = `${getComp(data, 'street_number')} ${getComp(data, 'route')}`

    if (setValue) {
      setValue(data['formatted_address'])
    }

    const { place_id } = data

    const { lat: latitude, lng: longitude } = await getLatLng(data)

    const gTimeRes = await fetch(
      `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=1331161200&key=${config.gmapsKey}`
    )

    const gTimeData = await gTimeRes.json()

    const { rawOffset, timeZoneId: ianaTimeZoneId } = gTimeData

    this.setState({ address })

    setAddressObj({
      city,
      stateCode,
      countryCode,
      postalCode,
      streetAddress,
      rawOffset,
      ianaTimeZoneId,
      placesId: place_id,
      latitude,
      longitude,
      UtcOffSet: rawOffset / 3600,
      TzTimeZoneName: ianaTimeZoneId
    })
  }

  render() {
    const { label, valid, className, disabled } = this.props

    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        searchOptions={{ language: 'en' }}
      >
        {({ getInputProps, getSuggestionItemProps, suggestions }) => (
          <div className={styles.autocomplete}>
            <TextInput
              {...getInputProps({
                label,
                className,
                valid,
                disabled
              })}
              autoComplete="disabled"
              type="search"
            />
            <div className={styles.suggestions}>
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? styles.suggestionItemActive
                  : styles.suggestionItem
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    )
  }
}

Autocomplete.propTypes = {
  setAddressObject: PropTypes.func,
  setAddressObj: PropTypes.func,
  className: PropTypes.string,
  value: PropTypes.string,
  setValue: PropTypes.func,
  setTimeZoneName: PropTypes.func,
  valid: PropTypes.bool,
  setValid: PropTypes.func,
  disabled: PropTypes.bool
}

export default Autocomplete
